/* eslint-disable react/jsx-pascal-case */
import { Button, Col, ConfigProvider, Form, Row, Modal } from "antd";
import dayjs from 'dayjs';
import React, { useContext, useEffect, useRef, lazy, Suspense, useState } from "react";
import NewsForm from "./NewsForm";
const { ConfigContext } = ConfigProvider


const NewsModal = (
    {
        axiosMode = "post",
        propsForm,
        propsOpen = null,
        propsLoading = null,
        propsSetOpen = () => {

        },
        onFinish = () => {

        }
    }
) => {

    const axiosModelanguage = {
        post: "新增",
        patch: "修改"
    }
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const [formReloadCount, setFormReloadCount] = useState(0)
    const showModal = () => {
        setFormReloadCount(pre => pre + 1)
        if (propsOpen === null) {
            setIsModalOpen(true);
        }
        else {
            propsSetOpen(true)
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        }
        else {
            propsSetOpen(false)
        }
    }

    const handleOk = () => {
        setLoading(true)
        if (propsForm) {
            propsForm.submit()
        }
        else {
            form.submit()
        }
    };
    const handleGenerate = () => {
        // setLoading(true)
        // if (propsForm) {
        //     propsForm.submit()
        // }
        // else {
        //     form.submit()
        // }
    };
    const handleCancel = () => {
        closeModal()
    };
    const onFormFinish = (values) => {
        onFinish(values)
    }
    useEffect(() => {
        setFormReloadCount(pre => pre + 1)
    }, [propsOpen])
    return (
        <>
            {
                propsOpen === null &&
                <Button type="primary" onClick={showModal}>
                    {
                        `${axiosModelanguage[axiosMode]}資料`
                    }
                </Button>
            }
            <Modal
                style={{ top: 10 }}
                title={`${axiosModelanguage[axiosMode]}資料`}
                open={propsOpen === null ? isModalOpen : propsOpen}
                onGenerate={handleGenerate}
                onOk={handleOk} 
                onCancel={handleCancel}
                confirmLoading={propsLoading === null ? loading : propsLoading}
                maskClosable={false}
                footer={<>
                            <Button onClick={handleGenerate}>
                                產生文案
                            </Button>
              
                            <Button onClick={handleOk}>
                                送出
                            </Button>
                            <Button onClick={handleCancel} variant="outline">
                                取消
                            </Button>
                    </>}
            >
                <Row
                    style={{
                        maxHeight: "80vh",
                        overflowX: "scroll",
                        overflowY: "scroll",
                    }}
                >
                    <Col span={24}>
                        <NewsForm
                            formReloadCount={formReloadCount}
                            open={propsOpen === null ? isModalOpen : propsOpen}
                            axiosMode={axiosMode}
                            propsForm={propsForm ? propsForm : form}
                            onFormFinish={onFormFinish}
                        />
                    </Col>
                </Row>
            </Modal>
        </>

    )
}


export default NewsModal;
